import { DEFAULT_CAPTION_FONT } from '@src/utility/captionFonts';

import type { KaraokeConfig } from './karaokeTypes';

export const MAX_GAP_DURATION = 1; // in second
export const MAX_CHARS_INSTAGRAM = 14;
export const MAX_CHARS_DEFAULT = 50;

export const NATURAL_BEAT_DURATION_MS = MAX_GAP_DURATION * 1000;
export const PAUSE_DURATION_MS = 300;
export const MAX_SEGMENT_CHAR_LENGTH = 40;
export const ORPHANED_WORDS_COUNT = 2;
export const PUNCT_ELEMENT_DURATION_MS = 0; // Estimated duration for punct elements

export const FILLER_WORDS = [
  'Umm',
  'Um',
  'Uh',
  'Uhh',
  'Eh',
  'You know',
  'Ya know',
  'Hmm',
  'Hm',
  'Ah',
  'Ahh',
  'Er',
];

export const DEFAULT_KARAOKE_CONFIG = {
  ...DEFAULT_CAPTION_FONT,
  width: '76%',
  font_size: '3.333vh',
  fill_color: 'white',
  background_color: 'transparent',
  background_align_threshold: '0%',
  background_border_radius: '0%',
  text_wrap: true,
  x_alignment: '50%',
  y: '86%',
  x: '50%',
  line_height: '125%',
  stroke_color: 'rgba(0, 0, 0, 1)',
  stroke_width: '1 vmin',
  letter_spacing: '50%',
  animations: [] as any[],
  hideComma: false,
  hidePeriod: false,
  hideFillers: false,
  instagramEffect: false,
  instagramLines: 5,
  language: 'original',
  shadow_color: null,
  shadow_blur: null,
  shadow_x: null,
  shadow_y: null,
  text_transform: 'uppercase',
} as KaraokeConfig;

export const WORDS_TIMESTAMP_FLOAT_ERROR = 1e-6;

export const DEFAULT_TEXT_TRANSCRIPT_CONFIG = {
  // transcript_effect is skipped on purpose, it will be used as flag to know if
  // user activated the transcript settings
  transcript_split: 'word',
  transcript_placement: 'animate',
  transcript_maximum_length: 100,
  transcript_color: 'rgba(231, 76, 60, 1)',
};
